import { defineMessages } from 'react-intl';
export default defineMessages({
	featureIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.feature-issue-type-name',
		defaultMessage: 'Feature',
		description: 'The name of the feature issue type',
	},
	featureIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.feature-issue-type-description',
		defaultMessage: 'A broad piece of functionality.',
		description: 'The description of the feature issue type',
	},
	taskIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.task-issue-type-name',
		defaultMessage: 'Task',
		description: 'The name of the task issue type',
	},
	taskIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.task-issue-type-description',
		defaultMessage: 'A small piece of work.',
		description: 'The description of the task issue type',
	},
	storyIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.story-issue-type-name',
		defaultMessage: 'Story',
		description: 'The name of the story issue type',
	},
	storyIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.story-issue-type-description',
		defaultMessage: 'A requirement expressed from the user’s perspective.',
		description: 'The description of the story issue type',
	},
	bugIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.bug-issue-type-name',
		defaultMessage: 'Bug',
		description: 'The name of the bug issue type',
	},
	bugIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.bug-issue-type-description',
		defaultMessage: 'A problem that needs fixing.',
		description: 'The description of the bug issue type',
	},
	assetIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.asset-issue-type-name',
		defaultMessage: 'Asset',
		description: 'The name of the asset issue type',
	},
	assetIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.asset-issue-type-description',
		defaultMessage: 'A file, image, or video.',
		description: 'The description of the asset issue type',
	},
	contactIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.contact-issue-type-name',
		defaultMessage: 'Contact',
		description: 'The name of the contact issue type',
	},
	contactIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.contact-issue-type-description',
		defaultMessage: 'A relevant point of contact.',
		description: 'The description of the contact issue type',
	},
	requestIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.request-issue-type-name',
		defaultMessage: 'Request',
		description: 'The name of the request issue type',
	},
	requestIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.request-issue-type-description',
		defaultMessage: 'An ask for assistance.',
		description: 'The description of the request issue type',
	},
	researchItemIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.research-item-issue-type-name',
		defaultMessage: 'Research Item',
		description: 'The name of the research item issue type',
	},
	researchItemIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.research-item-issue-type-description',
		defaultMessage: 'A sample of data or supporting information.',
		description: 'The description of the research item issue type',
	},
	incidentIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.incident-issue-type-name',
		defaultMessage: 'Incident',
		description: 'The name of the incident item issue type',
	},
	incidentIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.incident-issue-type-description',
		defaultMessage: 'An IT-related event requiring attention.',
		description: 'The description of the incident item issue type',
	},
	serviceRequestIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.service-request-issue-type-name',
		defaultMessage: 'Service Request',
		description: 'The name of the service request issue type',
	},
	serviceRequestIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.service-request-issue-type-description',
		defaultMessage: 'An ask for assistance from a customer service team.',
		description: 'The description of the service request item issue type',
	},
	supportIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.support-issue-type-name',
		defaultMessage: 'Support',
		description: 'The name of the support issue type',
	},
	supportIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.support-issue-type-description',
		defaultMessage: 'A request for help for customer support issues.',
		description: 'The description of the support issue type',
	},
	campaignIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.campaign-issue-type-name',
		defaultMessage: 'Campaign',
		description: 'The name of the support issue type',
	},
	campaignIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.campaign-issue-type-description',
		defaultMessage: 'A marketing strategy with a defined goal.',
		description: 'The description of the campaign issue type',
	},
	candidateIssueTypeName: {
		id: 'software-onboarding-modals.utils.wizard.candidate-issue-type-name',
		defaultMessage: 'Candidate',
		description: 'The name of the candidate issue type',
	},
	candidateIssueTypeDescription: {
		id: 'software-onboarding-modals.utils.wizard.candidate-issue-type-description',
		defaultMessage: 'A person in consideration for a role.',
		description: 'The description of the candidate issue type',
	},
	ideaColumnName: {
		id: 'software-onboarding-modals.utils.wizard.idea-column-name',
		defaultMessage: 'Idea',
		description: 'Idea column name',
	},
	todoColumnName: {
		id: 'software-onboarding-modals.utils.wizard.todo-column-name',
		defaultMessage: 'To Do',
		description: 'To Do column name',
	},
	inProgressColumnName: {
		id: 'software-onboarding-modals.utils.wizard.in-progress-column-name',
		defaultMessage: 'In Progress',
		description: 'In Progress column name',
	},
	inReviewColumnName: {
		id: 'software-onboarding-modals.utils.wizard.in-review-column-name',
		defaultMessage: 'In Review',
		description: 'In Review column name',
	},
	doneColumnName: {
		id: 'software-onboarding-modals.utils.wizard.done-column-name',
		defaultMessage: 'Done',
		description: 'Done column name',
	},
	testingColumnName: {
		id: 'software-onboarding-modals.utils.wizard.testing-column-name',
		defaultMessage: 'Testing',
		description: 'Testing column name',
	},
	inDesignColumnName: {
		id: 'software-onboarding-modals.utils.wizard.in-design-column-name',
		defaultMessage: 'In Design',
		description: 'In Design column name',
	},
	userTestingColumnName: {
		id: 'software-onboarding-modals.utils.wizard.user-testing-column-name',
		defaultMessage: 'User Testing',
		description: 'User Testing column name',
	},
	approvedColumnName: {
		id: 'software-onboarding-modals.utils.wizard.approved-column-name',
		defaultMessage: 'Approved',
		description: 'Approved column name',
	},
	liveColumnName: {
		id: 'software-onboarding-modals.utils.wizard.live-column-name',
		defaultMessage: 'Live',
		description: 'Live column name',
	},
	waitingForCustomerColumnName: {
		id: 'software-onboarding-modals.utils.wizard.waiting-for-customer-column-name',
		defaultMessage: 'Waiting for Customer',
		description: 'Waiting for customer column name',
	},
	resolvedColumnName: {
		id: 'software-onboarding-modals.utils.wizard.resolved-column-name',
		defaultMessage: 'Resolved',
		description: 'Resolved column name',
	},
});
